export default "./dist/stdassets/images/icons/view-back.png";